import { render, staticRenderFns } from "./ClaimAddWalletConfirm.vue?vue&type=template&id=5db9cfb9&scoped=true&"
import script from "./ClaimAddWalletConfirm.vue?vue&type=script&lang=js&"
export * from "./ClaimAddWalletConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAddWalletConfirm.vue?vue&type=style&index=0&id=5db9cfb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9cfb9",
  null
  
)

export default component.exports